export default "__VITE_ASSET__i6UdsIfo__"